import React, { CSSProperties, useState } from 'react';
import Button from '../../../components/CustomButtons/ButtonTS';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import SweetAlert from 'react-bootstrap-sweetalert';
import { sweetAlertStyle } from '../../helpers/CustomStyles';
import Card from '../../../components/Card/CardTS';
import CardBody from '../../../components/Card/CardBody';
import CardHeader from '../../../components/Card/CardHeaderTS';
import CardIcon from '../../../components/Card/CardIcon';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import DescriptionOutlined from '@material-ui/icons/DescriptionOutlined';
import Tooltip from "@material-ui/core/Tooltip";

type DeleteFileButtonProps = {
	file: any;
	deleteSystemFile: (ID: number) => void;
	setConfirmationAlert: (confAlert: any) => void;
};

const buttonStyle: CSSProperties = {
	textTransform: 'uppercase',
	margin: '15px',
};


const DeleteFileButton = ({
    file,
	deleteSystemFile,
	setConfirmationAlert
}: DeleteFileButtonProps) => {
	const [isButtonDisabled, setIsButtonDisabled] = useState(false);
	let confAlert: any = null;

	const showRemoveFileConfirmation = (): any => {
		setConfirmationAlert( 
			<SweetAlert
				title=''
				showConfirm={false}
				style={sweetAlertStyle}
				onConfirm={deleteFile}
				onCancel={()=>{setConfirmationAlert(<></>);}}
				key='remove-system-confirmation-alert'
			>
				<Card chart style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }} className='node-edit-card'>
				<CardHeader color='info' icon>
					<CardIcon color='info'>
						<DescriptionOutlined />
					</CardIcon>
					<h3  style={{color: 'black'}}>
						{`${file.filename}`}
					</h3>
				</CardHeader>
				<CardBody>
					<GridContainer>
						<GridItem xs={12}>
							<h5>This operation is irreversible.<br />Are you sure you want to delete this file?</h5>
						</GridItem>
						<GridItem xs={12} style={{ margin: '15px 0 0 0 ' }}>
							<div style={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>
								<Button
									className='deleteSystemCloseButton'
									simple
									color='info'
									onClick={()=>{setConfirmationAlert(<></>);}}
								>
									cancel
								</Button>
								<Button
									style={{ backgroundColor: '#f44336' }}
									onClick={deleteFile}
								>
									remove
								</Button>
							</div>
						</GridItem>
					</GridContainer>
				</CardBody>
			</Card>
			</SweetAlert>
		);
	};

	const deleteFile = () => {
		deleteSystemFile(file.id);
		setConfirmationAlert(<></>);
	};

	return (
		<Tooltip title='Delete'>
		<Button
			size='sm'
			style={buttonStyle}
			color='danger'
			onClick={showRemoveFileConfirmation}
			disabled={false}
		>
			<ClearOutlinedIcon/>
		</Button>
		</Tooltip>
	);
};

export default DeleteFileButton;
